import { render, staticRenderFns } from "./LikeLinkButton.vue?vue&type=template&id=de98f37e&scoped=true&"
import script from "./LikeLinkButton.vue?vue&type=script&lang=js&"
export * from "./LikeLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./LikeLinkButton.vue?vue&type=style&index=0&id=de98f37e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de98f37e",
  null
  
)

export default component.exports